import React, { useState, useEffect } from 'react';
import { Paper, makeStyles, Button } from '@material-ui/core';
import {getCrudTables} from '../../../Helpers/crudHelper';
import CrudTable from '../../Crud/CrudTable';
import {getCrudColumnList} from '../../../Helpers/crudHelper';
import {crudService} from '../../../Services/crudService';
import CrudAddEditDrawer from '../../Crud/CrudAddEditDrawer';
import ImportDialog from '../../Crud/ImportDialog';
import { toast } from 'react-toastify';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { useTranslation } from 'react-i18next';

export default function CrudPage(props) {
    const classes = useStyles();
    const [crudTitle, setTitle] = useState("");
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [tableList, setElements] = useState([]);
    const [columns, setColumns] = useState([]);
    const [rows, setRows] = useState([]);
    const [editId, setEditId] = useState(null);
    const [reload, setReload] = useState(false);
    const [foreignObjects, setForeignObject] = useState({});
    const [importFile, setImportFile] = useState(null);
    const [importPopupOpen, setimportPopupOpen] = useState(false);
    const { t } = useTranslation();

    useEffect(() => {
        if (reload === true){
            setReload(false);
        }

        setElements(getCrudTables());
        let mounted = true
        let columns = getCrudColumnList(props.crud.table)
        setColumns(columns);
        if (props.crud.api !== "" && props.crud.schemeName !== ""){
            crudService.tableOverview(props.crud.schemeName, props.crud.api, props.user.userToken).then(o => {
                if (mounted) {
                    setRows(o);
                }
            }).catch((error) => {toast.error(error, {position: toast.POSITION.TOP_CENTER})})

            let foreignData = []
            
            // get foreign data
            columns.forEach(element => {
                if(element.isForeignKey === "True") {
                    crudService.tableOverview(element.linkedSchema, element.linkedTable, props.user.userToken).then(o => {
                        if (mounted) {
                            foreignData[element.name] = o
                            setForeignObject(foreignData)
                        }
                    }).catch((error) => {toast.error(error, {position: toast.POSITION.TOP_CENTER})})
                }
            });
        }

        return function cleanup() {
            mounted = false
        }
      }, [props.crud.api, props.crud.schemeName, props.crud.table, props.user.userToken, reload]);

    const handleNewCrud = (event, table) => {
        if(table !== null){
            props.actions.setCrudTable(table.tableName);
            props.actions.setAPITable(table.apiName);
            props.actions.setSchemeName(table.schemeName);
        }
    }

    const openDrawer = (title, open, id) => {
      setTitle(title);
      setDrawerOpen(open);
      setEditId(id);
    }

    const uploadFile = (e) => {
        e.preventDefault();
        setImportFile(e.target.files[0]);
        setimportPopupOpen(true);
    }

    const handleImport = () => {
        setimportPopupOpen(false);
        var data = new FormData();
        data.append("body", importFile);

        crudService.importExcel(props.crud.schemeName, props.crud.api, props.user.userToken, data).then(() => setReload(true)).catch((error) => {toast.error(error, {position: toast.POSITION.TOP_CENTER})})
    }

    let defaultTableVal = tableList.find(v => v.tableName === props.crud.table) || {};

    return <div className="background">
        <div className={classes.page}>
            <div className={classes.topSpacer}></div>
                    
                    <div className={classes.toolbar}>
                        <Autocomplete
                        options={tableList}
                        getOptionLabel={tableList => tableList.tableName || ""}
                        value={defaultTableVal}
                        className={classes.combobox}
                        onChange={handleNewCrud}
                        renderInput={params => (
                            <TextField {...params} label="Kies een tabel" variant="outlined" />
                        )}
                        />
                        <div className={classes.buttongroup}>
                            <input
                                accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                                className={classes.input}
                                id="contained-button-file"
                                type="file"
                                onChange={uploadFile}
                            />
                            <label id="contained-button-file-label" htmlFor="contained-button-file" className={classes.ImportButton}>
                                <Button variant="contained" color="primary" component="span">
                                    {t('Import')}
                                </Button>
                            </label>
                            <Button className={classes.AddButton} variant="contained" color="primary" onClick={() => openDrawer("Add", true, null)}>{t('Add')}</Button>
                        </div>
                    </div>
                    <ImportDialog handleImport={handleImport} filename={importFile ? importFile.name : ""} open={importPopupOpen}></ImportDialog>
                    <div className={classes.spacer50}></div>
                    <div className={classes.spacer50}></div>
                    <Paper className={classes.paper}>
                        <CrudTable rows={rows} columns={columns} user={props.user} crud={props.crud} className={classes.table} openDrawer={openDrawer}></CrudTable>
                    </Paper>

                    <CrudAddEditDrawer setReload={setReload} foreignObjects={foreignObjects} user={props.user} crud={props.crud} title={crudTitle} openDrawer={openDrawer} columns={columns} drawerOpen={drawerOpen} editId={editId} rows={rows}></CrudAddEditDrawer>
            </div>
        </div>
}

const useStyles = makeStyles(() => ({
    spacer20: {
        height: '20px'  
    },

    spacer50: {
        height: '50px'  
    },

    topSpacer: {
        height: '68px'  
    },
  
      paper: {
          padding: '5px',
          height: '60%',
          width : "100%",
          overflow: "auto",
      },

      toolbar: {
        textAlign: "right"
      },

      AddButton: {
        marginLeft : "10px"
      },

      ImportButton: {
        marginLeft : "10px"
      },

      table: {
        height: '100%'  
      },

      input: {
         display: 'none',
      },

      combobox: {
        width: "50%",
        float : "left"
      },

      page : {
          paddingLeft: "50px",
          paddingRight: "50px",
          marginTop:"40px"

      },

      buttongroup : {
          width: "40%",
          float : "right"
      }
}));